import {
    FormFieldType, FormFieldVisibility,
} from "../../../__generated__/api";

import { VariablesInput } from "../../../components/agent-v3/editor/Variables";

export const WELCOME_VARIABLES: VariablesInput = {
    valueFormat: "fieldId",
    shouldReplaceVariables: true,
    variables: [
        {
            id: "request-fields",
            label: "Request Fields",
            description: "The following fields are available when creating a ticket.",
            input: [
                {
                    id: "TICKET_NUMBER",
                    name: "Ticket Number",
                    description: "The number for the newly created ticket.",
                    isSystemField: true,
                    type: FormFieldType.Text,
                    visibility: FormFieldVisibility.Reusable,
                },
                {
                    id: "FIRST_NAME",
                    name: "First Name",
                    description: "The first name of the requester that created the tiket",
                    isSystemField: true,
                    type: FormFieldType.Text,
                    visibility: FormFieldVisibility.Reusable,
                },
                {
                    id: "LAST_NAME",
                    name: "Last Name",
                    description: "The last name of the requester that created the tiket",
                    isSystemField: true,
                    type: FormFieldType.Text,
                    visibility: FormFieldVisibility.Reusable,
                },
                {
                    id: "NAME",
                    name: "Name",
                    description: "The first and last name of the requester that created the tiket",
                    isSystemField: true,
                    type: FormFieldType.Text,
                    visibility: FormFieldVisibility.Reusable,
                },
            ],
        },
    ],
};

export const TICKET_CREATED_MESSAGE_VARIABLES: VariablesInput = {
    valueFormat: "fieldId",
    shouldReplaceVariables: true,
    variables: [
        {
            id: "request-fields",
            label: "Request Fields",
            description: "The following fields are available when creating a ticket.",
            input: [
                {
                    id: "SUBJECT",
                    name: "Subject",
                    description: "The subject of the created ticket.",
                    isSystemField: true,
                    type: FormFieldType.Text,
                    visibility: FormFieldVisibility.Reusable,
                },
                {
                    id: "DESCRIPTION",
                    name: "Description",
                    description: "The description of the new ticket",
                    isSystemField: true,
                    type: FormFieldType.Text,
                    visibility: FormFieldVisibility.Reusable,
                },
                {
                    id: "DESCRIPTION_OR_SUBJECT",
                    name: "Description or Subject",
                    description: "The description, but if the description does not exist, will instead use the subject.",
                    isSystemField: true,
                    type: FormFieldType.Text,
                    visibility: FormFieldVisibility.Reusable,
                },
                {
                    id: "TICKET_NUMBER",
                    name: "Ticket Number",
                    description: "The ticket number.",
                    isSystemField: true,
                    type: FormFieldType.Text,
                    visibility: FormFieldVisibility.Reusable,
                },
                {
                    id: "PRIORITY",
                    name: "Priority",
                    description: "The selected priority of the ticket.",
                    isSystemField: true,
                    type: FormFieldType.Text,
                    visibility: FormFieldVisibility.Reusable,
                },
                {
                    id: "STATUS",
                    name: "Status",
                    description: "The status of the ticket.",
                    isSystemField: true,
                    type: FormFieldType.Text,
                    visibility: FormFieldVisibility.Reusable,
                },
                {
                    id: "CREATOR",
                    name: "Creator",
                    description: "The user that created the ticket",
                    isSystemField: true,
                    type: FormFieldType.Text,
                    visibility: FormFieldVisibility.Reusable,
                },
                {
                    id: "REQUESTOR",
                    name: "Requester",
                    description: "The user that requested the ticket.",
                    isSystemField: true,
                    type: FormFieldType.Text,
                    visibility: FormFieldVisibility.Reusable,
                },

            ],
        },
    ],
};
